(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var themeStrings = (window.theme && window.theme.strings) || {};

  function getFocusable(root) {
    return [].slice.call(root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) {
        return !el.closest('[inert]') && getComputedStyle(el).visibility !== 'hidden' &&
          !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
      });
  }

  function trapFocus(root, e) {
    if (e.key !== 'Tab') return;
    var focusable = getFocusable(root);
    if (!focusable.length) { e.preventDefault(); return; }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (!root.contains(document.activeElement)) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
    } else if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* Nav scroll hide: hides on the first downward scroll, comes back after
     scrolling up REVEAL px in total (measured from the lowest point reached,
     so slow finger and trackpad scrolls count too). Also with reduced
     motion: base.css then drops the slide, so it just disappears */
  (function () {
    var nav = document.getElementById('site-nav');
    if (!nav) return;
    var lastY = window.scrollY;
    var deepest = lastY;
    var ticking = false;
    var REVEAL = 16;
    function blocked() {
      return nav.classList.contains('is-open') ||
        nav.classList.contains('nav-pinned') ||
        document.body.classList.contains('ap-panel-open');
    }
    function update() {
      var y = window.scrollY;
      nav.classList.toggle('nav-scrolled', y > 0);
      if (blocked()) {
        nav.classList.remove('nav-is-hidden');
        lastY = deepest = y;
        ticking = false;
        return;
      }
      if (y <= 0) {
        nav.classList.remove('nav-is-hidden');
        deepest = y;
      } else if (y > lastY) {
        nav.classList.add('nav-is-hidden');
        deepest = y;
      } else if (deepest - y >= REVEAL) {
        nav.classList.remove('nav-is-hidden');
      }
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
  })();

  /* One choreography controller for existing panels and native dialogs. */
  var panels = {}, activePanel = null;
  var motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  function panelState() {
    var any = Object.keys(panels).some(function (key) { return panels[key].open; });
    document.body.classList.toggle('ap-panel-open', any);
    document.dispatchEvent(new Event('ap:panelchange'));
  }
  function stagger(panel) {
    var items = panel.kind === 'menu' ? panel.root.querySelectorAll('.nav-links > a, :scope > .nav-lang') :
      panel.kind === 'cart' ? panel.root.querySelectorAll('.cart-drawer-head, .cart-drawer-body > *, .cart-drawer-foot') : panel.root.querySelectorAll(':scope > li');
    items.forEach(function (el, i) {
      el.classList.add('ap-stagger');
      el.style.setProperty('--ap-delay', (panel.kind === 'cart' ? 80 + i * (items.length > 5 ? 15 : 40) : panel.kind === 'menu' ? 120 + i * 40 : 80 + i * 40) + 'ms');
    });
  }
  function finishPanel(panel, restore) {
    clearTimeout(panel.timer);
    panel.root.classList.remove('is-closing', 'is-open');
    if (panel.host !== panel.root) panel.host.classList.remove('is-closing', 'is-open');
    if (panel.scrim) panel.scrim.classList.remove('is-open', 'is-closing');
    panel.open = false;
    if (panel.kind === 'dialog') { if (panel.root.open) panel.nativeClose(); }
    else {
      panel.root.inert = panel.kind !== 'menu' || window.innerWidth <= 920;
      panel.root.setAttribute('aria-hidden', panel.root.inert ? 'true' : 'false');
    }
    if (panel.triggerButton) panel.triggerButton.setAttribute('aria-expanded', 'false');
    if (panel.kind === 'cart') panel.triggerButton.dataset.apX = 'false';
    if (panel.kind === 'menu') {
      panel.triggerButton.dataset.apX = 'false';
      panel.triggerButton.setAttribute('aria-label', themeStrings.openMenu || 'Open menu');
      document.body.classList.remove('nav-open');
      if (panels.lang && panels.lang.open) finishPanel(panels.lang, false);
    }
    if (panel.kind === 'lang') document.getElementById('site-nav').classList.remove('nav-pinned');
    if (panel.kind === 'cart') document.body.classList.remove('cart-open');
    if (activePanel === panel) activePanel = panel.kind === 'lang' && panels.menu.open ? panels.menu : null;
    panelState();
    if (restore && panel.trigger && panel.trigger.isConnected && !panel.trigger.closest('[inert]')) panel.trigger.focus({ preventScroll: true });
  }
  function closePanel(panel, restore, immediate) {
    if (!panel || !panel.open) return;
    if (immediate || motionPreference.matches) { finishPanel(panel, restore); return; }
    if (panel.triggerButton) panel.triggerButton.setAttribute('aria-expanded', 'false');
    if (panel.kind === 'menu' || panel.kind === 'cart') panel.triggerButton.dataset.apX = 'false';
    panel.root.classList.add('is-closing');
    if (panel.host !== panel.root) panel.host.classList.add('is-closing');
    if (panel.scrim) panel.scrim.classList.add('is-closing');
    panel.root.inert = true;
    clearTimeout(panel.timer);
    panel.timer = setTimeout(function () { finishPanel(panel, restore); }, 340);
  }
  function openPanel(panel, trigger) {
    if (!panel) return;
    Object.keys(panels).forEach(function (key) {
      var other = panels[key];
      /* Language is an existing child popup inside the mobile menu host. */
      if (other !== panel && other.open && !(panel.kind === 'lang' && other.kind === 'menu' && window.innerWidth <= 920)) finishPanel(other, false);
    });
    clearTimeout(panel.timer);
    panel.trigger = trigger || document.activeElement;
    panel.open = true; activePanel = panel;
    if (nav) nav.classList.remove('nav-is-hidden');
    panel.root.inert = false;
    panel.root.setAttribute('aria-hidden', 'false');
    panel.root.classList.remove('is-closing');
    panel.host.classList.remove('is-closing');
    stagger(panel);
    if (panel.kind === 'dialog') { if (!panel.root.open) panel.nativeShow(); }
    else { panel.host.classList.add('is-open'); panel.root.classList.add('is-open'); }
    if (panel.scrim) panel.scrim.classList.add('is-open');
    if (panel.triggerButton) panel.triggerButton.setAttribute('aria-expanded', 'true');
    if (panel.kind === 'menu') {
      panel.triggerButton.dataset.apX = 'true';
      panel.triggerButton.setAttribute('aria-label', themeStrings.closeMenu || 'Close menu');
      document.body.classList.add('nav-open');
    }
    if (panel.kind === 'cart') { document.body.classList.add('cart-open'); panel.triggerButton.dataset.apX = 'true'; }
    if (panel.kind === 'lang') document.getElementById('site-nav').classList.add('nav-pinned');
    panelState();
    if (panel.kind !== 'dialog') (getFocusable(panel.root)[0] || panel.triggerButton || panel.root).focus({ preventScroll: true });
  }
  var nav = document.getElementById('site-nav'), menu = document.getElementById('primary-nav'), menuButton = document.getElementById('nav-menu-btn');
  if (nav && menu && menuButton) {
    panels.menu = { kind: 'menu', root: menu, host: nav, triggerButton: menuButton, open: false };
    var originalIcon = menuButton.querySelector('.nav-menu-lines');
    if (originalIcon) {
      var defaultIcon = document.createElement('span'), closeIcon = document.createElement('span');
      defaultIcon.className = 'ap-menu-icon ap-icon-default'; closeIcon.className = 'ap-menu-icon ap-icon-x';
      defaultIcon.setAttribute('aria-hidden', 'true'); closeIcon.setAttribute('aria-hidden', 'true');
      originalIcon.replaceWith(defaultIcon); defaultIcon.appendChild(originalIcon); closeIcon.appendChild(originalIcon.cloneNode(true)); menuButton.appendChild(closeIcon);
    }
    menuButton.onclick = function (e) { e.stopPropagation(); if (panels.menu.open && !menu.classList.contains('is-closing')) closePanel(panels.menu, true); else openPanel(panels.menu, menuButton); };
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { closePanel(panels.menu, false); }); });
    function syncMenu() { if (window.innerWidth > 920 && panels.menu.open) finishPanel(panels.menu, false); menu.inert = window.innerWidth <= 920 && !panels.menu.open; menu.setAttribute('aria-hidden', String(menu.inert)); }
    window.addEventListener('resize', syncMenu); syncMenu();
  }
  var langWrap = document.getElementById('lang-wrap'), langMenu = document.getElementById('lang-menu'), langButton = document.getElementById('lang-toggle');
  if (langWrap && langMenu && langButton) {
    panels.lang = { kind: 'lang', root: langMenu, host: langWrap, triggerButton: langButton, open: false };
    langMenu.inert = true;
    function syncLanguageLinks() {
      var current = new URL(window.location.href);
      langMenu.querySelectorAll('a[hreflang]').forEach(function (link) {
        var destination = new URL(link.href, current);
        destination.search = current.search;
        destination.hash = current.hash;
        link.href = destination.href;
      });
    }
    langButton.onclick = function (e) { e.stopPropagation(); syncLanguageLinks(); if (panels.lang.open) closePanel(panels.lang, true); else openPanel(panels.lang, langButton); };
    langMenu.addEventListener('pointerdown', syncLanguageLinks);
    langMenu.addEventListener('focusin', syncLanguageLinks);
    langMenu.addEventListener('click', syncLanguageLinks);
    langWrap.addEventListener('click', function (e) { e.stopPropagation(); });
  }
  function bindCartDrawer() {
    var drawer = document.getElementById('cart-drawer'), scrim = document.getElementById('cart-scrim'), button = document.getElementById('nav-cart-btn');
    if (!drawer || !scrim || !button) return;
    var p = panels.cart;
    if (!p || p.root !== drawer) p = panels.cart = { kind: 'cart', root: drawer, host: drawer, scrim: scrim, triggerButton: button, open: false };
    drawer.inert = !p.open;
    button.onclick = function (e) { e.preventDefault(); if (p.open) closePanel(p, true); else openPanel(p, button); };
    drawer.querySelectorAll('#cart-close, [data-cart-continue]').forEach(function (b) { b.onclick = function () { closePanel(p, true); }; });
    scrim.onclick = function () { closePanel(p, true); };
    window.AhmadCart = window.AhmadCart || {};
    window.AhmadCart.open = function (trigger) { var from = trigger || document.activeElement; if (!from || from === document.body || from.closest('#cart-drawer')) from = button; openPanel(p, from); };
    window.AhmadCart.close = function () { closePanel(p, true); };
    window.AhmadCart.refreshCount = function (count) { var countEl = document.getElementById('nav-cart-count'); if (countEl) { countEl.textContent = count; countEl.hidden = !Number(count); } document.querySelectorAll('[data-cart-count-pill]').forEach(function (pill) { pill.textContent = count; pill.hidden = !Number(count); }); button.setAttribute('aria-label', (themeStrings.cart || 'Cart') + ', ' + count + ' ' + (themeStrings.items || 'items')); };
    window.AhmadCart.refreshDrawer = refreshCartDrawer;
    window.AhmadCart.rebind = bindCartDrawer;
  }
  function refreshCartDrawer() {
    var sectionId = (window.theme && window.theme.cartSection) || 'cart-drawer';
    var rootUrl = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
    return fetch(rootUrl + '?sections=' + encodeURIComponent(sectionId)).then(function (r) { return r.json(); }).then(function (data) {
      if (!data[sectionId]) return;
      var incoming = new DOMParser().parseFromString(data[sectionId], 'text/html');
      var body = document.getElementById('cart-drawer-body'), drawer = document.getElementById('cart-drawer');
      var rows = body ? body.querySelectorAll('[data-line-key]').length : 0;
      ['cart-drawer-head', 'cart-drawer-body', 'cart-drawer-foot'].forEach(function (id) { var from = incoming.getElementById(id), to = document.getElementById(id); if (from && to) { to.innerHTML = from.innerHTML; to.hidden = from.hidden; } });
      /* A row came or went while the drawer is open: fade the new contents in instead of snapping. */
      if (body && drawer && drawer.classList.contains('is-open') && !motionPreference.matches && body.querySelectorAll('[data-line-key]').length !== rows) {
        body.classList.remove('ap-cart-swap'); void body.offsetWidth; body.classList.add('ap-cart-swap');
        body.addEventListener('animationend', function done(e) { if (e.target !== body) return; body.classList.remove('ap-cart-swap'); body.removeEventListener('animationend', done); });
      }
      bindCartDrawer();
    });
  }
  bindCartDrawer();
  document.querySelectorAll('#cart-confirmation, #photo-zoom').forEach(function (dialog) {
    var p = panels[dialog.id] = { kind: 'dialog', root: dialog, host: dialog, open: false, nativeShow: dialog.showModal.bind(dialog), nativeClose: dialog.close.bind(dialog) };
    dialog.showModal = function () { openPanel(p, document.activeElement); };
    dialog.close = function () { closePanel(p, true); };
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); closePanel(p, true); });
    dialog.addEventListener('click', function (e) { if (e.target !== dialog) return; var r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closePanel(p, true); });
  });
  document.addEventListener('keydown', function (e) {
    if (!activePanel || !activePanel.open) return;
    if (e.key === 'Escape') { e.preventDefault(); closePanel(activePanel, true); }
    else trapFocus(activePanel.root, e);
  });
  document.addEventListener('click', function (e) {
    if (panels.lang && panels.lang.open && !langWrap.contains(e.target)) closePanel(panels.lang, true);
    if (panels.menu && panels.menu.open && e.target === menu) closePanel(panels.menu, true);
  });
  motionPreference.addEventListener('change', function () { if (motionPreference.matches && nav) nav.classList.remove('nav-is-hidden'); if (motionPreference.matches) Object.keys(panels).forEach(function (key) { var p = panels[key]; if (p.root.classList.contains('is-closing')) finishPanel(p, true); }); });

  /* Cart toast */
  (function () {
    var toast = document.getElementById('cart-toast');
    if (!toast) return;
    var timer, exitTimer;
    var defaultMsg = toast.textContent.trim();

    function hideToast() {
      clearTimeout(exitTimer);
      toast.classList.add('is-closing');
      function finishToast() { toast.classList.remove('is-visible', 'is-closing', 'toast--action'); toast.hidden = true; toast.removeAttribute('aria-label'); }
      if (motionPreference.matches) finishToast(); else exitTimer = setTimeout(finishToast, 340);
    }

    window.showCartToast = function (msg) {
      if (!msg && window.matchMedia('(min-width: 921px)').matches && window.AhmadCart && window.AhmadCart.open) {
        clearTimeout(timer);
        hideToast();
        window.AhmadCart.open();
        return;
      }
      var isAction = !msg;
      toast.textContent = msg || defaultMsg;
      toast.classList.toggle('toast--action', isAction);
      if (isAction) {
        toast.setAttribute('aria-label', defaultMsg.replace(/\s*·.*$/, '') + '. Open cart.');
      } else {
        toast.removeAttribute('aria-label');
      }
      clearTimeout(exitTimer);
      toast.classList.remove('is-closing');
      toast.hidden = false;
      toast.classList.add('is-visible');
      clearTimeout(timer);
      timer = setTimeout(hideToast, 4000);
    };

    toast.addEventListener('click', function () {
      if (!toast.classList.contains('toast--action')) return;
      clearTimeout(timer);
      hideToast();
      if (window.AhmadCart && window.AhmadCart.open) window.AhmadCart.open();
    });
  })();

})();

